import axios, { AxiosError } from "axios";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { LoadReferralRequestModel, ReferralInProgress } from "./models";

const submitReferral = (questions: AnsweredQuestionWithId[], apiUrl: string, referAgainOhCaseId: string | undefined) => {
    return axios.post(apiUrl, { questions, referAgainOhCaseId });
};

const saveReferral = async (
    questions: AnsweredQuestionWithId[],
    eTag: string | null | undefined,
    isInitial: boolean,
    referAgainOhCaseId: string | undefined
) => {
    try {
        const referralInProgress: ReferralInProgress = {
            data: { questions },
            eTag,
            isInitial,
            referAgainOhCaseId
        };
        const response = await axios.post<ReferralInProgress>("/api/referral/save", referralInProgress);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError.response?.status === 400) {
            const error = { message: "Could not save as a newer version exists", status: 400 };
            throw error;
        } else {
            throw ex;
        }
    }
};

const loadReferral = (requestModel: LoadReferralRequestModel, abortController?: AbortController) => {
    if (requestModel.customerId && requestModel.ohCaseId) {
        // Use only provided apiUrl
        return axios.get(requestModel.apiUrl, { signal: abortController?.signal });
    }
    else if (requestModel.ohCaseId) {
        // View completed form
        return axios.get(`${requestModel.apiUrl}/${requestModel.ohCaseId}`, { signal: abortController?.signal });
    } else {
        // Create form
        return axios.get(`${requestModel.apiUrl}/${requestModel.customerId}/${requestModel.questionnaireId}`, { signal: abortController?.signal });
    }
};

export const referralApi = { submitReferral, saveReferral, loadReferral };
